export { getWishlistServerAction } from 'next-flight-server-reference-proxy-loader?id=00e0f56b07a1281bd7af905594571002fa6f7dab54&name=getWishlistServerAction!'